import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ProviderDatesRequest } from "@src/services/provider-dates.service";
import type { ApiCallConfig } from "@src/utils/api-client";
import { buildProviderDatesUpstreamQueryParams } from "@src/utils/provider-dates-query-params";

/**
 * Builds the callApi config for the provider-dates endpoint.
 * Delegates query-param construction to the shared buildProviderDatesUpstreamQueryParams utility.
 */
export function buildProviderDatesConfig(request: ProviderDatesRequest): ApiCallConfig {
  const queryParams = buildProviderDatesUpstreamQueryParams({
    practice_id: request.practiceId,
    department_id: request.departmentIds,
    provider_id: request.providerId,
    start_date: request.startDate,
    end_date: request.endDate,
    care_format: request.careFormat,
    user_uuid: request.user_uuid,
    user_timezone: request.user_timezone,
    speciality: request.speciality,
    daysoftheweek: request.daysOfTheWeek,
    ageserved: request.ageServed,
    packageID: request.packageId,
    minimum_day_time: request.minimum_day_time,
    clinician_type: request.clinicianType,
    duration: request.duration,
  });

  return {
    method: HTTP_METHODS.GET,
    endpoint: INTERNAL_API_ENDPOINTS.PROVIDER_DATES,
    queryParams,
  };
}
